import 'angular';

import { EditTimesheetCtrl }       from './schedule.timesheet.edit.ajs';
import { HolidayCtrl }             from './schedule.holiday';
import { ManageHolidaysCtrl }      from './schedule.manage-holidays';
import { Schedule }                from './schedule.service';
import { ScheduleCtrl }            from './schedule';
import { ScheduleStates }          from './schedule.states.ajs';
import { SetUnavailableTimesCtrl } from './schedule.set-unavailable-times.ajs';
import { Timesheet }               from './schedule.timesheet.directive';

angular.module('workshop.schedule', [])
.controller('EditTimesheetCtrl', EditTimesheetCtrl)
.controller('HolidayCtrl', HolidayCtrl)
.controller('ManageHolidaysCtrl', ManageHolidaysCtrl)
.controller('ScheduleCtrl', ScheduleCtrl)
.controller('SetUnavailableTimesCtrl', SetUnavailableTimesCtrl)
.directive('timesheet', Timesheet)
.factory('Schedule', Schedule)
.config(ScheduleStates);